import { createBrowserRouter, redirect } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";

import dashboardRoutes from "./views/dashboard/dashboardRoutes";
import pagesRoutes from "./views/pages/pagesRoutes";
import iconsRoutes from "./views/icons/iconsRoutes";
import formsRoutes from "./views/forms/formsRoutes";
import chartsRoute from "./views/charts/chartsRoute";
import uiKitsRoutes from "./views/ui-kits/uiKitsRoutes";
import widgetsRoute from "./views/widgets/widgetsRoute";
import dataTableRoute from "./views/data-table/dataTableRoute";
import extraKitsRoutes from "./views/extra-kits/extraKitsRoutes";
import chatRoutes from "./views/app/chat/chatRoutes";
import inboxRoutes from "./views/app/inbox/inboxRoutes";
import invoiceRoutes from "./views/app/invoice/invoiceRoutes";
import contactRoutes from "./views/app/contact/contactRoutes";
import calendarRoutes from "./views/app/calendar/calendarRoutes";
import ecommerceRoutes from "./views/app/ecommerce/ecommerceRoutes";
import taskManagerRoutes from "./views/app/task-manager/taskManagerRoutes";
import timesheetRoutes from "./views/Timesheet/timesheetRoutes";
import hrcal from "./views/HR Cal/hrcalRoutes";
import usersRoute from "./views/user/usersRoute";                         // <--- user route
import organizationRoute from "./views/organization/organizationRoute";    // <--- organization route
import assetRoutes from "./views/assets/assetRoute";
import employeeRoutes from './views/employees/employeeRoutes';
import eventsRoutes from "./views/events/eventsRoutes";
import processManagementRoutes from "./views/process-management/processManagementRoutes";
import masterRoutes from "./views/master/masterRoutes";
import partRoutes from "./views/part/partRoutes";
import componentRoutes from "./views/component/componentRoutes";
import Error404 from "./views/sessions/Error";
import sessionsRoutes from "./views/sessions/sessionsRoutes";
import productRoutes from "./views/product/productRoutes";
import reportRoutes from "./views/reports/reportRoutes";



export const protectedRoutes = [
  ...dashboardRoutes,
  ...usersRoute,                           // <--- user route
  ...employeeRoutes,
  ...organizationRoute,                    // <--- organization Route
  ...assetRoutes,                      // AssetRoutes
  ...timesheetRoutes,
  ...uiKitsRoutes,
  ...formsRoutes,
  ...widgetsRoute,
  ...chartsRoute,
  ...dataTableRoute,
  ...extraKitsRoutes,
  ...pagesRoutes,
  ...iconsRoutes,
  ...invoiceRoutes,
  ...inboxRoutes,
  ...calendarRoutes,
  ...taskManagerRoutes,
  ...ecommerceRoutes,
  ...contactRoutes,
  ...chatRoutes,
  ...hrcal,
  ...eventsRoutes,
  ...processManagementRoutes,
  ...masterRoutes,
  ...partRoutes,
  ...componentRoutes,
  ...productRoutes,
  ...reportRoutes

];
const routes = createBrowserRouter([
  {
    element: <AuthGuard />,
    children: protectedRoutes
  },
  ...sessionsRoutes,
  { path: "/", loader: () => redirect("/dashboard/production") },
  { path: "*", element: <Error404 /> }
]);

export default routes;
